(() => {
  const CONTAINER_SEL = ".shopify_subscriptions_app_container";
  const PERKS_MARKER_ATTR = "data-perks-injected";

  const perksOneTimeHTML = `
    <ul class="purchase-perks purchase-perks--onetime">
      <li class="purchase-perks__item is-x">No free shipping</li>
    </ul>
  `;

  const perksSubHTML = `
    <ul class="purchase-perks purchase-perks--sub">
      <li class="purchase-perks__item is-check">Free shipping</li>
      <li class="purchase-perks__item is-check">Ships every 30 days</li>
      <li class="purchase-perks__item is-check">Pause or cancel anytime</li>
    </ul>
  `;

  function injectInto(container) {
    if (!container || container.getAttribute(PERKS_MARKER_ATTR) === "true") return;

    // 1) One-time row (wrapper is the div that contains the label + price)
    const oneTimeRow = container.querySelector(
      ".shopify_subscriptions_purchase_option_wrapper:has(input[data-radio-type='one_time_purchase'])"
    );

    // 2) Subscribe header block (the block that contains the selling plan list)
    const subBlock = container.querySelector(
      ".shopify_subscriptions_app_block_label:has(ul.shopify_subscriptions_app_block_label_children)"
    );

    // Fallbacks for older Safari (no :has)
    const fallbackOneTimeRow =
      oneTimeRow ||
      container.querySelector(".shopify_subscriptions_purchase_option_wrapper")?.querySelector("input[data-radio-type='one_time_purchase']")
        ? container.querySelector(".shopify_subscriptions_purchase_option_wrapper")
        : null;

    const fallbackSubBlock =
      subBlock ||
      Array.from(container.querySelectorAll(".shopify_subscriptions_app_block_label")).find((el) =>
        el.querySelector("ul.shopify_subscriptions_app_block_label_children")
      );

    const finalOneTimeRow = oneTimeRow || fallbackOneTimeRow;
    const finalSubBlock = subBlock || fallbackSubBlock;

    if (finalOneTimeRow && !finalOneTimeRow.querySelector(".purchase-perks")) {
      finalOneTimeRow.insertAdjacentHTML("beforeend", perksOneTimeHTML);
    }

    if (finalSubBlock && !finalSubBlock.querySelector(".purchase-perks")) {
      // Put perks right under the subscribe header wrapper, before the list of plans
      const childrenList = finalSubBlock.querySelector("ul.shopify_subscriptions_app_block_label_children");
      if (childrenList) {
        childrenList.insertAdjacentHTML("beforebegin", perksSubHTML);
      } else {
        finalSubBlock.insertAdjacentHTML("beforeend", perksSubHTML);
      }
    }

    container.setAttribute(PERKS_MARKER_ATTR, "true");
  }

  function run() {
    document.querySelectorAll(CONTAINER_SEL).forEach(injectInto);
  }

  // Initial
  document.addEventListener("DOMContentLoaded", run);

  // Subscriptions app block can re-render on variant change; observe DOM changes
  const obs = new MutationObserver(run);
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Also run after any change in the subscriptions fieldset
  document.addEventListener("change", (e) => {
    if (e.target && (e.target.matches(".shopify_subscriptions_fieldset input[type='radio']") || e.target.name === "id")) {
      run();
    }
  });
})();